<template>
  <div class="row-component">
    <div
      @click="$emit('toggleDescriptionRow', !detailRowVisible)"
      class="clickable"
    >
      <slot name="titleRow" class="titleRow">
        Parent should provide title row template
      </slot>
    </div>

    <b-collapse v-model="detailRowVisible" class="descriptionRow">
      <slot name="descriptionRow">
        Parent should provide detail row template
      </slot>
    </b-collapse>
  </div>
</template>

<script>
  export default {
    name: 'rowComponent',
    props: {
      detailRowVisible: {
        type: Boolean,
        default: false
      }
    }
  }
</script>
<style scoped lang="scss">
  .row-component
    .clickable:hover {
      cursor: pointer;
    }
</style>
